import { render, staticRenderFns } from "./ContenedorPreguntas.vue?vue&type=template&id=0df3ac06&scoped=true"
import script from "./ContenedorPreguntas.vue?vue&type=script&lang=js"
export * from "./ContenedorPreguntas.vue?vue&type=script&lang=js"
import style0 from "./ContenedorPreguntas.vue?vue&type=style&index=0&id=0df3ac06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df3ac06",
  null
  
)

export default component.exports